<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col>
        <h3>Raport dotyczące postępów w nauce przez kursanta</h3>
        <b-row>
          <b-col>
            <b-form-group label="Od" class="required">
              <date-picker
                v-model="startDate"
                :config="calendarOptions"
                language="pl"
                autocomplete="off"
                :class="{'is-invalid': $v.startDate.$error}"
              ></date-picker>
              <b-form-invalid-feedback v-if="!$v.startDate.required">To pole jest wymagane</b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Do" class="required">
              <date-picker
                v-model="endDate"
                :config="calendarOptions"
                language="pl"
                autocomplete="off"
                :class="{'is-invalid': $v.endDate.$error}"
              ></date-picker>
              <b-form-invalid-feedback>
                <div :force-show="!$v.endDate.isEndAfterStart">Data od musi poprzedzać datę do</div>
                <div v-if="!$v.endDate.required">To pole jest wymagane</div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group class="required" label="Student">
              <b-form-select
                v-model="selectedStudent"
                :options="students"
                :state="$v.selectedStudent.$error? false : null"
                @input="$v.selectedStudent.$reset()"
              ></b-form-select>
              <b-form-invalid-feedback>
                <div v-if="!$v.selectedStudent.required">To pole jest wymagane</div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col>
            <b-button-toolbar class="float-right">
              <b-button
                class="mx-1"
                type="submit"
                variant="primary"
                :disabled="loading"
                @click.prevent="onPreview"
              >
                <span v-show="!loading">
                  <font-awesome-icon icon="file-pdf"></font-awesome-icon>&nbsp;Podgląd
                </span>
                <span v-show="loading">
                  <b-spinner small label="Loading..."></b-spinner>
                </span>
              </b-button>

              <b-button
                type="submit"
                variant="primary"
                :disabled="loading"
                @click.prevent="onDownload"
              >
                <span v-show="!loading">
                  <font-awesome-icon icon="file-download"></font-awesome-icon>&nbsp;Pobierz
                </span>
                <span v-show="loading">
                  <b-spinner small label="Loading..."></b-spinner>
                </span>
              </b-button>
            </b-button-toolbar>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
</style>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, helpers } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  data() {
    return {
      loading: true,

      startDate: "",
      endDate: "",
      selectedStudent: null,
      students: [{ value: null, text: "" }],
      calendarOptions: {
        format: "YYYY-MM-DD",
        locale: "pl",
        useCurrent: true
      }
    };
  },
  validations: {
    selectedStudent: {
      required
    },
    endDate: {
      isEndAfterStart: function() {
        return (
          !helpers.req(this.endDate) ||
          moment(this.endDate).isSameOrAfter(this.startDate)
        );
      },
      required
    },
    startDate: {
      required
    }
  },
  mounted() {
    axios
      .get("students/all")
      .then(result => {
        result.data.forEach(element => {
          this.students.push({
            value: element.id,
            text: element.lastName + " " + element.firstName
          });
        });
      })
      .catch(err => {
        eventBus.$emit("unhandled-error", err);
        return null;
      })
      .then(() => (this.loading = false));
  },
  methods: {
    onPreview() {
      this.onSubmit(false);
    },
    onDownload() {
      this.onSubmit(true);
    },
    onSubmit(download) {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.loading = true;

        axios({
          method: "post",
          url: "reports/pdf/student/progress",
          responseType: "blob",
          data: {
            userId: this.selectedStudent,
            from: this.startDate,
            to: this.endDate
          }
        })
          .then(function(response) {
            let link = document.createElement("a");
            link.setAttribute("type", "hidden");
            link.href = window.URL.createObjectURL(response.data);
            if (download) {
              link.download = "Report.pdf";
              document.body.appendChild(link);
              link.click();
            } else {
              window.open(link);
            }
            link.remove();
          })
          .catch(err => {
            eventBus.$emit("unhandled-error", err);
          })
          .then(() => (this.loading = false));
      }
    }
  }
};
</script>
